import { faArrowLeft, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@heroui/react";
import { useNavigate } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

function DefaultError({ error }: { error?: unknown }) {
    const navigate = useNavigate();

    useEffect(() => {
        if (error) {
            Sentry.captureException(error);
        }
    }, [error]);

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6">
            <div className="flex flex-col items-center gap-2">
                <h2 className="text-lg font-bold text-gray-800">
                    Something went wrong
                </h2>
                <p className="text-gray-500 text-center max-w-md text-sm">
                    An unexpected error occurred. Please try again or go back to
                    the previous page.
                </p>
            </div>
            <div className="flex gap-3">
                <Button
                    variant="flat"
                    color="secondary"
                    size="sm"
                    onPress={() => navigate({ to: "..", replace: true })}
                    startContent={<FontAwesomeIcon icon={faArrowLeft} />}
                >
                    Go Back
                </Button>
                <Button
                    color="primary"
                    size="sm"
                    onPress={() => window.location.reload()}
                    startContent={<FontAwesomeIcon icon={faRefresh} />}
                >
                    Try Again
                </Button>
            </div>
        </div>
    );
}

export default DefaultError;
